module.exports = __webpack_public_path__ + "media/images/footer/koelnbusiness-8a8c886c22cb5e74ec7e442e126705e9.svg";